import { type FunctionComponent } from 'react';
import { generateCloudinaryUrl } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { type PromoBannerVariationOptions } from '../../../types/promo-banner.types';
import { StyledButton } from '../../buttons';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { BannerImage } from '../banner-image/banner-image.component';
import { DoorMarker } from '../promo-helpers/door-marker.component';
import { defaultCouponExpirationString } from '../promo-helpers/promo-banner.helpers';
import { SecondaryPromoC } from '../secondary-variations/secondary-promo-c.component';

export const PromoBannerC: FunctionComponent<PromoBannerVariationOptions> = (props) => {
	const { headline, subHeading, couponCode, expirationDate, action, image, imageShade, imageOverlay } = props;

	const backgroundUrl = generateCloudinaryUrl(image.id, {
		width: 400,
		height: undefined,
		gravity: 'custom',
		zoom: '0.9',
		crop: 'thumb'
	});

	return (
		<>
			<div className="dn-ns">
				<SecondaryPromoC {...props} />
			</div>
			<div className="ba b--theme-grey-light dn db-ns">
				<div className="flex">
					<div className="pa3 w-70 w-60-l">
						<div className="b f3 theme-primary">{headline}</div>
						<div className="f5 lh-title mt3 theme-grey-darker">{subHeading}</div>
						{(couponCode || expirationDate) && (
							<div className="f5 mt2 theme-grey-darker">
								<DoorMarker />
								<span className="nowrap">{defaultCouponExpirationString(couponCode, expirationDate)}</span>
							</div>
						)}
						{action && (
							<div className="mt3">
								<StyledButton>{action.name}</StyledButton>
							</div>
						)}
					</div>
					<BannerImage className="min-h4 relative w-30 w-40-l" backgroundUrl={backgroundUrl} imageShade={imageShade}>
						{imageOverlay && (
							<CloudinaryImage
								publicID={imageOverlay.id}
								description="promo"
								className="absolute bottom-0 max-h-100 pa3 right-0"
								options={{
									width: 100,
									height: undefined,
									crop: 'lfill',
									gravity: 'custom',
									preserveTransparency: true
								}}
								useDimensions={false}
							/>
						)}
					</BannerImage>
				</div>
			</div>
		</>
	);
};
